import { resolveVariantFromProps as t } from "./atoms-v2948.js";
function s(r, n, o) {
  const e = r.getProps();
  return t(e, n, o !== void 0 ? o : e.custom, r);
}
export {
  s as resolveVariant
};
